// Screenshot URL per Feature Matrix key (shots/<key>.jpg, made by
// scripts/feature-previews/capture.cjs). Only the URLs are bundled.
const SHOTS = import.meta.glob('./shots/*.jpg', { eager: true, query: '?url', import: 'default' });

export const shotFor = (key) => SHOTS[`./shots/${key}.jpg`] || null;
